<p class="text-center mb-2">
    {{'captcha.label' | translate}}
    <app-help-info [label]="'captcha.tooltip' | translate"></app-help-info>
</p>
<re-captcha (emptied)="onChange(false)"
            (ended)="onChange(false)"
            (error)="onChange(false)"
            (resolved)="onChange($event)"
            [siteKey]="siteKey"></re-captcha>
